/*
 *
 * TermsAndConditions reducer
 *
 */

import { fromJS } from 'immutable';
import {
  FETCH_CURRENT_TERMS_AND_CONDITIONS,
  FETCH_CURRENT_TERMS_AND_CONDITIONS_ERROR,
  FETCH_CURRENT_TERMS_AND_CONDITIONS_SUCCESS,
} from './constants';

export const initialState = fromJS({
  loading: false,
  error: false,
  data: null,
});

function termsAndConditionsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CURRENT_TERMS_AND_CONDITIONS:
      return state.set('loading', true);
    case FETCH_CURRENT_TERMS_AND_CONDITIONS_ERROR:
      return state.set('loading', false).set('error', action.error);
    case FETCH_CURRENT_TERMS_AND_CONDITIONS_SUCCESS:
      return state.set('loading', false).set('data', action.termsAndConditions);
    default:
      return state;
  }
}

export default termsAndConditionsReducer;
